import { Component } from '@angular/core';

@Component({
  selector: 'ngx-pop-out-layout',
  styleUrls: ['./pop-out.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-column withScroll>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class PopOutLayoutComponent {}
